import React from 'react'

export default function IconEnvelope({ color = 'currentColor', ...rest }) {
    return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            <path
                d='M14.4016 6.4946L8.00156 9.6946L1.60156 6.4946V11.2002C1.60156 11.6245 1.77013 12.0315 2.07019 12.3316C2.37025 12.6316 2.77722 12.8002 3.20156 12.8002H12.8016C13.2259 12.8002 13.6329 12.6316 13.9329 12.3316C14.233 12.0315 14.4016 11.6245 14.4016 11.2002V6.4946Z'
                fill={color}
            />
            <path
                d='M1.60396 4.7074L8.00155 7.9058L14.3992 4.7074C14.3755 4.29975 14.1968 3.91659 13.8998 3.63638C13.6028 3.35617 13.2099 3.20012 12.8016 3.2002H3.20156C2.79322 3.20012 2.40031 3.35617 2.1033 3.63638C1.80628 3.91659 1.62764 4.29975 1.60396 4.7074Z'
                fill={color}
            />
        </svg>
    )
}
